import React from 'react';
import { generateDestinationMapLink } from '../../sitewide/components/locationMap/helpers/googleMapApi';
import { Column } from '@codeparva/ui-components-library';
import { ContactUsPageTypes } from '../ContactUsPageTypes';
import { useVariant } from '../hooks/VariantContext';

export const ClickableContactDiv = ({
  text,
  type,
  url,
  addressDetails,
  className = '',
  onCustom,
  children,
}: ContactUsPageTypes.TClickableDiv) => {
  const variant = useVariant();
  const handleAddress = () => {
    if (addressDetails) {
      const { gMapDetails, googleMapPlaceId } = addressDetails;
      const destination = {
        coords: {
          lat: gMapDetails.geometry.location.lat,
          lng: gMapDetails.geometry.location.lng,
        },
        placeId: googleMapPlaceId,
      };
      return generateDestinationMapLink(destination);
    } else {
      return '';
    }
  };

  const switchCase = () => {
    const linksLookupTable = {
      ['phone']: `tel:${text}`,
      ['email']: `mailto:${text}`,
      ['address']: handleAddress() || url,
      ['link']: text,
      ['default']: '',
    };
    return linksLookupTable[type as keyof typeof linksLookupTable];
  };

  const targetType = {
    phone: '_self',
    email: '_self',
    address: '_blank',
    link: '_blank',
    custom: undefined,
  };

  return (
    <Column className="listItem">
      <a
        className={`clickableTextContainer ${className} ${
          variant === 'newContactUsDarkTheme'
            ? 'is-flex is-flex-direction-column'
            : 'is-flex'
        }`}
        href={switchCase() || undefined}
        onClick={type === 'custom' ? onCustom : undefined}
        target={targetType[type]}
        rel="nofollow"
      >
        <>{children}</>
      </a>
    </Column>
  );
};
